import { render, staticRenderFns } from "./global-alignment-settings.vue?vue&type=template&id=34dc85a7"
import script from "./global-alignment-settings.vue?vue&type=script&lang=js"
export * from "./global-alignment-settings.vue?vue&type=script&lang=js"
import style0 from "./global-alignment-settings.vue?vue&type=style&index=0&id=34dc85a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports